module.exports = __webpack_public_path__ + "img/saki.a8557c1c.png";